export const backUrl =
  process.env.NODE_ENV === "production" && navigator.userAgent !== "ReactSnap"
    ? process.env.REACT_APP_API_URL
    : "http://localhost:5000/api";
export const businessUrl = process.env.REACT_APP_BUSINESS_URL;
